module.exports = __webpack_public_path__ + "media/images/menu/news-8a80fb973e9e782c31a4aa3cb5bc4567.jpg";